import { Component, inject } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { debounceTime, map } from "rxjs/operators";
import {
  CstListViewDataSource,
  ICstListViewColumn,
  ICstListViewState,
} from "src/app/common-components/list-view/models";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";
import {
  AnlagenClientProvider,
  StandortDetailDto,
} from "src/app/web-api/web-api";

export interface IAnlageApiFacilityLocationSelectDialogData {
  searchText?: string;
}

@Component({
    templateUrl: "./facility-location-select.component.html",
    styleUrls: ["./facility-location-select.component.scss"],
    standalone: false
})
export class AnlageApiFacilityLocationSelectDialogComponent extends CstResponsivePopupComponentBase<IAnlageApiFacilityLocationSelectDialogData> {
  private _client = inject(AnlagenClientProvider);

  formFilter: FormGroup = null;

  columns: ICstListViewColumn<StandortDetailDto>[] = [
    {
      field: "name",
      header: $localize`:@@AnlageAPI_FacilityLocationSelect_Header_Name:Name`,
      width: "150%",
    },
    {
      field: "street",
      header: $localize`:@@AnlageAPI_FacilityLocationSelect_Header_Street:Street`,
    },
    {
      field: "streetNo",
      header: $localize`:@@AnlageAPI_FacilityLocationSelect_Header_StreetNo:Street No.`,
      width: "75%",
    },
    {
      field: "postalCode",
      header: $localize`:@@AnlageAPI_FacilityLocationSelect_Header_PostalCode:Postal Code`,
      width: "75%",
    },
    {
      field: "city",
      header: $localize`:@@AnlageAPI_FacilityLocationSelect_Header_City:City`,
      width: "80%",
    },
    {
      field: "facilityNo",
      header: $localize`:@@AnlageAPI_FacilityLocationSelect_Header_FacilityNo:Facility No.`,
      width: "100%",
      overflow: "ellipsis",
    },
    {
      field: "country",
      header: $localize`:@@AnlageAPI_FacilityLocationSelect_Header_Country:Country`,
    },
  ];

  dataSource = new CstListViewDataSource<StandortDetailDto>({
    pagination: { pageSize: 10 },
  });

  constructor() {
    const fb = inject(FormBuilder);

    super();
    this.formFilter = fb.group({
      searchText: [""],
    });
    this.formFilter.valueChanges
      .pipe(debounceTime(1000))
      .subscribe(this._OnFilterChanged.bind(this));
    this.dataSource.registerFetchDataCallback(this._LoadStandorte.bind(this));
  }

  onInitialised() {
    if (this.data) {
      this.formFilter.patchValue(this.data);
    } else {
      this.dataSource.refresh();
    }
  }
  private _LoadStandorte(state: ICstListViewState) {
    const filter = this.formFilter.value as { searchText: string };
    return this._client
      .getStandorte(
        filter.searchText,
        state.pagination.offset,
        state.pagination.pageSize
      )
      .pipe(map((result) => ({ data: result.data, total: result.total })));
  }

  private _OnFilterChanged() {
    this.dataSource.refresh();
  }

  public OnLocationSelect(item: StandortDetailDto) {
    this.close(item);
  }
}
